import React, { useEffect } from 'react';

import { registerPrototypeMount } from '../../stores/prototype-mount-store';

interface PrototypeBoundaryProps {
  children?: React.ReactNode;
}

/**
 * Marks its subtree as prototype content for the lifetime of the mount.
 * `<PrototypeModeIndicator>` reads the resulting mount count so the viewport
 * indicator only appears when a prototype is actually on screen.
 */
export const PrototypeBoundary: React.FC<PrototypeBoundaryProps> = ({ children }) => {
  useEffect(() => registerPrototypeMount(), []);
  return <>{children}</>;
};
